import { Grid } from "@material-ui/core";
import {
    Collections,
    Round,
    StatusRoundDescription,
    Track,
    useCollection,
} from "api";
import { DateTime } from "luxon";
import MaterialTable from "material-table";
import React, { useMemo, useState } from "react";
import { WhereOptions } from "react-redux-firebase";
import { useHistory } from "react-router";
import {
    BoxCard,
    ConfirmationDialog,
    ConfirmationDialogState,
    PageLayout,
} from "ui/componentes";
import { LocalizationPTBr } from "util/MaterialTableUtil";

const clearConfirmation = (setConfirmation) => () =>
    setConfirmation({ title: "", message: "", showDialog: false });

const RaceControlView = () => {
    const [confirmation, setConfirmation] = useState<ConfirmationDialogState>({
        showDialog: false,
        message: "",
    });
    const history = useHistory();

    const tracksById =
        useCollection<{ [key: string]: Track }>({
            collection: Collections.TRACKS,
        }) || {};

    const where = useMemo(() => {
        const where: WhereOptions[] = [
            ["date", ">=", DateTime.local().toFormat("yyyy-MM-dd")],
        ];
        return where;
    }, []);

    let rounds =
        useCollection<Round[]>(
            {
                collection: Collections.ROUNDS,
                where,
                orderBy: ["date", "asc"],
                limit: 10,
                storeAs: "nextAnalysis",
            },
            true
        ) || [];

    const championships = useCollection<object>({
        collection: Collections.CHAMPIONSHIPS,
    });

    const actions = useMemo(() => {
        const actions = [
            {
                tooltip: "Ir para moderação",
                icon: "description",
                onClick: (event, round) => {
                    history.push(`/race_control/${round["id"]}/false`);
                },
            },
        ];
        actions.push({
            tooltip: "Mensagens para transmissão",
            icon: "dvr",
            onClick: (event, round) => {
                history.push(`/broadcast_messages/${round["id"]}`);
            },
        });

        return actions;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <PageLayout title="Próximas moderações" showInBoxCard={false}>
            <ConfirmationDialog
                title={confirmation.title}
                showDialog={confirmation.showDialog}
                message={confirmation.message}
                onOk={confirmation.onOk}
                onCancel={clearConfirmation(setConfirmation)}
            />
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <MaterialTable
                        components={{ Container: BoxCard }}
                        columns={[
                            {
                                title: "Data",
                                field: "date",
                                align: "center",
                                render: (round) =>
                                    DateTime.fromISO(round.date).toFormat(
                                        "dd/MM/yyyy"
                                    ),
                            },
                            {
                                title: "Campeonato",
                                field: "championship",
                                render: (round) => {
                                    if (
                                        championships &&
                                        championships[round.championshipId]
                                    ) {
                                        return championships[
                                            round.championshipId
                                        ]["name"];
                                    }
                                    return "";
                                },
                            },
                            {
                                title: "Etapa",
                                field: "trackId",
                                render: (round) =>
                                    tracksById[round.trackId]?.friendlyName,
                            },
                            {
                                title: "Status",
                                field: "status",
                                render: (round) =>
                                    StatusRoundDescription[round.status],
                            },
                        ]}
                        data={rounds}
                        actions={actions}
                        localization={LocalizationPTBr}
                        options={{
                            showTitle: false,
                            paging: false,
                            sorting: false,
                            draggable: false,
                            search: false,
                        }}
                    />
                </Grid>
            </Grid>
        </PageLayout>
    );
};

export default RaceControlView;
export { RaceControlView };
